<template>
	<div class="login-container">
		<div class="login-main">
			<div class="l-header">
				<div class="t">账号登录</div>
				<a href="javascript:" class="ico-code"></a>
			</div>
			<el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="box-form login" autocomplete="on" label-position="left">
				<el-form-item prop="username" class="txt">
					<span class="svg-container"><i class="el-icon-user" /></span>
					<el-input ref="username" v-model="loginForm.username" placeholder="请输入用户名" name="" type="text" tabindex="1" autocomplete="on" />
				</el-form-item>
				<el-tooltip :enterable="false" v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
					<el-form-item prop="password" class="txt">
						<span class="svg-container"><i class="el-icon-lock" /></span>
						<el-input
							:key="passwordType"
							ref="password"
							v-model="loginForm.password"
							:type="passwordType"
							placeholder="请输入密码"
							name=""
							tabindex="2"
							autocomplete="on"
							auto-complete="new-password"
							@keyup.native="checkCapslock"
							@blur="capsTooltip = false"
							@keyup.enter.native="handleLogin"
						/>
						<span class="show-pwd" @click="showPwd"><svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" /></span>
					</el-form-item>
				</el-tooltip>
				<div class=""><el-checkbox v-model="isRememberPassword">记住密码</el-checkbox></div>
				<el-button :loading="loading" type="primary" @click.native.prevent="handleLogin" class="btn">登 录</el-button>
			</el-form>
		</div>

		<div class="tc copyright">
			© 广州同望科技发展有限公司
			<span style="margin-left:50px;">4000646100</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Login',
	components: {},
	data() {
		return {
			isRememberPassword: false,
			loginForm: {
				username: '',
				password: ''
			},
			loginRules: {
				username: [
					{
						required: true,
						trigger: 'blur'
					}
				],
				password: [
					{
						required: true,
						trigger: 'blur'
					}
				]
			},
			passwordType: 'password',
			capsTooltip: false,
			loading: false,
			showDialog: false,
			redirect: undefined,
			otherQuery: {}
		};
	},
	watch: {
		$route: {
			handler: function(route) {
				const query = route.query;
				if (query) {
					this.redirect = query.redirect;
					this.otherQuery = this.getOtherQuery(query);
				}
			},
			immediate: true
		}
	},
	created() {
		// window.addEventListener('storage', this.afterQRScan)
		this.initPassword();
	},
	mounted() {
		if (this.loginForm.username === '') {
			this.$refs.username.focus();
		} else if (this.loginForm.password === '') {
			this.$refs.password.focus();
		}
		window.addEventListener('keydown', this.keyDown);
	},
	destroyed() {
		// window.removeEventListener('storage', this.afterQRScan)
	},
	methods: {
		keyDown(e) {
			//如果是回车则执行登录方法
			if (e.keyCode == 13) {
				let closeBtn = document.querySelector('.el-dialog__close');
				closeBtn && closeBtn.click();
				this.handleLogin();
			}
		},
		checkCapslock(e) {
			const { key } = e;
			this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z');
		},
		showPwd() {
			if (this.passwordType === 'password') {
				this.passwordType = '';
			} else {
				this.passwordType = 'password';
			}
			this.$nextTick(() => {
				this.$refs.password.focus();
			});
		},
		handleLogin() {
			let loadingObj = this.$baseLoading();
			let password = window.btoa(this.loginForm.password + '');
			let reqData = { username: this.loginForm.username, password: password };
			this.$store
				.dispatch('user/login2', reqData)
				.then(res => {
					setTimeout(function() {
						loadingObj.close();
					}, 200);
					if (res.type == 'success') {
						this.rememberPassword();
						this.$router.push({
							path: '/'
						});
						this.loading = false;
						window.removeEventListener('keydown', this.keyDown, false);
					} else {
						setTimeout(function() {
							loadingObj.close();
						}, 200);
					}
				})
				.catch(e => {
					this.loading = false;
					setTimeout(function() {
						loadingObj.close();
					}, 200);
					console.error(e);
				});
		},
		getOtherQuery(query) {
			return Object.keys(query).reduce((acc, cur) => {
				if (cur !== 'redirect') {
					acc[cur] = query[cur];
				}
				return acc;
			}, {});
		},
		initPassword() {
			var u = localStorage.getItem('login_info');
			var login_info;
			if (u) {
				login_info = JSON.parse(u);
				var username = login_info.username;
				var password = login_info.password;
				var isRememberPassword = login_info.isRememberPassword;
				if (isRememberPassword == 'true') {
					this.isRememberPassword = true;
					this.loginForm.username = username;
					this.loginForm.password = password;
				}
			}
		},
		rememberPassword() {
			if (this.isRememberPassword) {
				var username = this.loginForm.username;
				var password = this.loginForm.password;
				var login_info = { username: username, password: password, isRememberPassword: 'true' };
				localStorage.setItem('login_info', JSON.stringify(login_info));
			} else {
				localStorage.removeItem('login_info');
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '@/resources/css/login.scss';
</style>
